import classnames from "classnames";
import { useCallback } from "react";
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectAppLoggedIn } from '../../app/appSelectors';

import { MainHeader } from '../../components/main-header/MainHeader';
import { Link } from 'react-router-dom';
import { useResponsive } from "../../components/responsive";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";
import ProfileButton from '../Account/components/ProfileButton/ProfileButton';
import { useGTMEvent } from "../GoogleTagManager/googleTagManagerHooks";
import { LANG_CHOOSER_TYPES, LangChooser } from "../LangChooser";

import {
    WelcomeHeaderControlPanelStyled, WelcomeHeaderLangChooserContainerStyled
} from './styled/WelcomeHeaderStyled.js';
import { RouterPaths } from "../../app/appConstants";

const ControlPanelComponent = ({ LinkComponent = Link, loggedIn }) => {
    const { getLangPath } = useLangContext();
    const { isMediumMaxWidth, isSmallMaxWidth } = useResponsive();
    const { handleGTMClick } = useGTMEvent({ module: 'Header' });

    const handleLoginClick = useCallback(() => handleGTMClick({ button: 'LogIn' }), [handleGTMClick])
    const handleSignUpClick = useCallback(() => handleGTMClick({ button: 'SignUp' }), [handleGTMClick])

    return (<WelcomeHeaderControlPanelStyled>
            {loggedIn ? (<ProfileButton/>) : (<>
                    <Button variant="link" as={LinkComponent} to={RouterPaths.login} onClick={handleLoginClick} type="button"
                            size="sm">
                        {getLangPath('promo.fx.log_in')}
                    </Button>
                    {/*<Button variant={'outline-primary'} size={'sm'} as={LinkComponent} onClick={handleSignUpClick}*/}
                    {/*        to={RouterPaths.registration}>*/}
                    {/*    {getLangPath('sign_up.title')}*/}
                    {/*</Button>*/}
                    <WelcomeHeaderLangChooserContainerStyled>
                        <LangChooser
                            isHideButtonArrowIcon={isMediumMaxWidth}
                            isHideButtonName={isSmallMaxWidth}
                            gtmModule="Header"
                            type={isMediumMaxWidth ? LANG_CHOOSER_TYPES.slider : LANG_CHOOSER_TYPES.dropdown}
                        />
                    </WelcomeHeaderLangChooserContainerStyled>
                </>)}
        </WelcomeHeaderControlPanelStyled>);
};

const WelcomeHeader = ({ LinkComponent, loggedIn, background, positionFixed, hideLogo }) => {
    const className = classnames({'position-fixed': positionFixed})
    return (<MainHeader background={background} className={className} hideLogo={hideLogo}>
        <ControlPanelComponent loggedIn={loggedIn} LinkComponent={LinkComponent}/>
    </MainHeader>);
};

const mapStateToProps = createStructuredSelector({
    loggedIn: makeSelectAppLoggedIn(),
});

export default connect(mapStateToProps)(WelcomeHeader);
